import type { GeniusDeepLinkExamContext } from "./resolveGeniusDeepLinkExamContext";

const ACTIVE_OR_DONE_STATUSES = new Set([
  "in_progress",
  "started",
  "attempted",
  "markscalculated",
  "missed",
  "submitted",
]);

export function shouldShowGeniusAssessmentNotAvailable(
  context: GeniusDeepLinkExamContext | null,
): boolean {
  if (!context) return true;

  const status = context.examStatus.trim().toLowerCase();
  if (ACTIVE_OR_DONE_STATUSES.has(status)) return false;

  if (context.startTime) {
    const startMs = new Date(context.startTime).getTime();
    if (!Number.isNaN(startMs)) return false;
  }

  return true;
}
